import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'COUNT',
  category: FunctionCategory.STATS,
  description: 'Counts all non-null values in a single column OR across each row of multiple columns.',
  shortDescription: 'Count',
  params: [
    {
      name: 'column',
      type: ArgType.any,
      description: 'A column.',
    },
  ],
  repeatableLastParamType: ArgType.any,
  repeatableLastParamDescription: 'Additional columns.',
} satisfies AnalysisFunction;
